import Icons from '../component/module.icons';
// import SVG from 'react-inlinesvg';
// import Wysiwyg from "../static/icons/add_text.svg"
// import TabBtn from "../static/icons/tab-icon.svg" 
// import Image from "../static/icons/image.svg"
// import Video from "../static/icons/video.svg"
// import Svg from "../static/icons/svg.svg"

function stripImg(string) {
    var x = string.replace('img/', '');
    // var y = x.replace('.png', "");
    return x;
  }
  
  function getFileType(string) {
    let fileType;
    var ext = string.split('.').pop();
    switch (ext.toLowerCase()) {
      case "png":
        fileType = "img";
        break;
      case "jpg":
        fileType = "img";
        break;
      case "jpeg":
        fileType = "img";
        break;
      case "webp":
        fileType = "img";
        break;
      case "mp4":
        fileType = "vid";
        break;
      case "webm":
        fileType = "vid";
        break;
      case "mov":
        fileType = "vid";
        break;
      case "svg":
        fileType = "svg";
        break;
      default:
        break;
    }
    return fileType;
  }
  
  
  function fileNameType(string, layerName, type) {
    if (!string) {
      return [];
    }
    let x0 = string.replace('img/', '');
    let x1 = x0.replace('svg/', '');
    let x1b = x1.replace('video/', '');
    let x1c = x1b.replace('narrative/', '');
    let x = x1c.replace('library/', '');
    var ext = string.split('.').pop();
    let x2;
    if (layerName) {
      x2 = layerName;
    } else {
      x2 = x.replace('.'+ ext, '');
    }
    if (type && type !== 'text') {
      ext = type
    }
    // console.log('fileNameType', ext, x2, string, type);
    let icon;
    switch (ext.toLowerCase()) {
      case "png":
        icon = <Icons.Image className="icon" />
        break;
      case "jpg":
        icon = <Icons.Image className="icon" />
        break;
      case "jpeg":
        icon = <Icons.Image className="icon" />
        break;
      case "img":
        icon = <Icons.Image className="icon" />
        break;
      case "webp":
        icon = <Icons.Image className="icon" />
        break;
      case "webm":
        icon = <Icons.Video className="icon" />
        break;
      case "vid":
        icon = <Icons.Video className="icon" />
        break;
      case "svg":
        icon = <Icons.Svg className="icon" />
        break;
      case "mp4":
        icon = <Icons.Video className="icon" />
        break;
      case "mov":
        icon = <Icons.Video className="icon" />
        break;
      case "tab":
        icon = <Icons.TabBtn className="icon" />
        break;
      case "grp":
        icon = <Icons.Folder className="icon" />
        break;
      case "popup":
        icon = <Icons.AddPopUp className="icon" />
        break;
      case "rect":
        icon = <Icons.Rectangle className="icon" />;
        break;
      case "rectangle":
        icon = <Icons.Rectangle className="icon" />;
        break;
      case "ellipse":
        icon = <Icons.Ellipse className="icon" />;
        break;
      case "arrow":
        icon = <Icons.Arrow className="icon" />;
        break;
      case "star":
        icon = <Icons.Star className="icon" />;
        break;
      case "line":
        icon = <Icons.Line className="icon" />;
        break;
      case "drawing":
        icon = <Icons.Drawing className="icon" />;
        break;
      case "path":
        icon = <Icons.Drawing className="icon" />;
        break;
      default:
        icon = <Icons.Wysiwyg className="icon" />
        break;
    }
    if (x2.length > 20) {
      x2 = x2.substring(0,20) + ' ...'
    }
    let result = [icon, x2];
    return result;
  }

  function fileNameTypeString(string, layerName, type) {
    let iconString;
    let x0 = string.replace('img/', '');
    let x1 = x0.replace('svg/', '');
    let x1b = x1.replace('video/', '');
    let x1c = x1b.replace('narrative/', '');
    let x = x1c.replace('library/', '');
    var ext = string.split('.').pop();
    let x2;
    if (layerName) {
      x2 = layerName;
    } else {
      x2 = x.replace('.'+ext, '');
    }
    if (type) {
      ext = type
    }

    if (type === 'vid') {
      ext = 'mp4'
    }
    if (type === 'img') {
      ext = 'png'
    }
    // console.log('fileNameType', ext, x2, string);
    let icon;
    const Image = '<svg width="12" height="12" viewBox="0 0 12 12"><path fill="white" id="image_FILL0_wght400_GRAD0_opsz48" d="M7,18a1.025,1.025,0,0,1-1-1V7A1.025,1.025,0,0,1,7,6H17a1.025,1.025,0,0,1,1,1V17a1.025,1.025,0,0,1-1,1Zm0-1H17V7H7Zm.933-1.617h8.15l-2.45-3.267-2.2,2.85L9.883,12.85ZM7,17v0Z" transform="translate(-6 -6)"/></svg>'
    const Svg = '<svg width="14.4" height="18" viewBox="0 0 14.4 18"><path fill="white" id="note_add_FILL0_wght400_GRAD0_opsz48" d="m1.35,18C.61,17.98.02,17.39,0,16.65V1.35C.02.61.61.02,1.35,0h8.12l4.93,4.93v11.72c-.02.74-.61,1.33-1.35,1.35H1.35Zm7.45-12.47V1.35H1.35v15.3h11.7V5.53h-4.25ZM1.35,1.35"/><path fill="white" d="m1.98,10.45l.92-.2c.1.41.32.57.63.57.26,0,.41-.12.41-.31,0-.23-.3-.33-.66-.46-.52-.17-1.16-.39-1.16-1.13,0-.66.54-1.1,1.32-1.1.63,0,1.32.27,1.47,1.02l-.84.19c-.11-.31-.28-.45-.57-.45-.25,0-.44.11-.44.29,0,.19.27.27.6.38.54.16,1.24.38,1.24,1.2,0,.68-.55,1.13-1.39,1.13-.79,0-1.43-.41-1.53-1.13Z"/><path fill="white" d="m7.82,7.91h.99l-1.32,3.59h-1.15l-1.32-3.59h.99l.9,2.62.9-2.62Z"/><path fill="white" d="m8.81,9.71c0-1.11.78-1.87,1.87-1.87.72,0,1.3.33,1.61.88l-.81.44c-.16-.29-.45-.46-.8-.46-.54,0-.94.41-.94,1.02s.35,1.02.94,1.02c.34,0,.69-.14.84-.52h-.8v-.74h1.71v2.03h-.72v-.39c-.23.27-.57.46-1.08.46-1.06,0-1.81-.76-1.81-1.87Z"/></svg>'
    const Video = '<svg width="14" height="11.2" viewBox="0 0 14 11.2"><path fill="white" d="m5.5,8.5l4.5-3-4.5-3v6Zm-4.5,2.7c-.3,0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.8V1c0-.3.1-.5.3-.7.2-.2.5-.3.7-.3h11.9c.3,0,.5.1.7.3.3.2.4.5.4.7v9.1c0,.3-.1.5-.3.7s-.5.3-.7.3H1v.1Zm0-1.1h11.9V1H1v9.1Zm0,0V1v9.1Z"/></svg>'
    const TabBtn = '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"> <path fill="white" d="M7,20V9c0-0.5,0.2-1,0.6-1.4C8,7.2,8.5,7,9,7h11c0.6,0,1,0.2,1.4,0.6C21.8,8,22,8.4,22,9v11c0,1.1-0.9,2-2,2h-3H9 c-0.6,0-1-0.2-1.4-0.6S7,20.5,7,20z M2,6.2c-0.1-0.5,0-1,0.3-1.5S3.1,4,3.7,3.9L14.5,2c0.6-0.1,1,0,1.5,0.3c0.4,0.3,0.7,0.8,0.8,1.3 L17.1,5H15l-0.2-1L4,5.9l1,5.7v7c-0.3-0.1-0.5-0.3-0.7-0.6C4.1,17.7,4,17.4,4,17.1L2,6.2z M9,9v11h7h4V9H9z"/></svg>'
    const Wysiwyg = '<svg width="20" height="16" viewBox="0 0 20 16" fill="none"><path d="M5 16V3H0V0H13V3H8V16H5ZM14 16V8H11V5H20V8H17V16H14Z" fill="white"/></svg>'
    const Folder = '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2033_1429)"><path d="M2 16.5C1.45 16.5 0.979167 16.3042 0.5875 15.9125C0.195833 15.5208 0 15.05 0 14.5V2.5C0 1.95 0.195833 1.47917 0.5875 1.0875C0.979167 0.695833 1.45 0.5 2 0.5H8L10 2.5H18C18.55 2.5 19.0208 2.69583 19.4125 3.0875C19.8042 3.47917 20 3.95 20 4.5V14.5C20 15.05 19.8042 15.5208 19.4125 15.9125C19.0208 16.3042 18.55 16.5 18 16.5H2ZM2 14.5H18V4.5H9.175L7.175 2.5H2V14.5Z" fill="white"/></g><defs><clipPath id="clip0_2033_1429"><rect width="20" height="16" fill="white" transform="translate(0 0.5)"/></clipPath></defs></svg>';
    const Popup = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20L7.325 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H12.675L10 20ZM10 16.4L11.6 14H18V2H2V14H8.4L10 16.4Z" fill="white"/></svg>';
    const rect = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M120-120v-720h720v720H120Zm80-80h560v-560H200v560Zm0 0v-560 560Z"/></svg>';
    const ellipse = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>';
    const arrow = '<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14"><path d="M13,14l-1.43-1.4,4.6-4.6H0v-2h16.18L11.6,1.4l1.4-1.4,7,7-7,7Z" fill="#fff"/></svg>';
    const star = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"/></svg>';
    const line = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M199-199q-9-9-9-21t9-21l520-520q9-9 21-9t21 9q9 9 9 21t-9 21L241-199q-9 9-21 9t-21-9Z"/></svg>';
    const path = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M554-120q-54 0-91-37t-37-89q0-76 61.5-137.5T641-460q-3-36-18-54.5T582-533q-30 0-65 25t-83 82q-78 93-114.5 121T241-277q-51 0-86-38t-35-92q0-54 23.5-110.5T223-653q19-26 28-44t9-29q0-7-2.5-10.5T250-740q-10 0-25 12.5T190-689l-70-71q32-39 65-59.5t65-20.5q46 0 78 32t32 80q0 29-15 64t-50 84q-38 54-56.5 95T220-413q0 17 5.5 26.5T241-377q10 0 17.5-5.5T286-409q13-14 31-34.5t44-50.5q63-75 114-107t107-32q67 0 110 45t49 123h99v100h-99q-8 112-58.5 178.5T554-120Zm2-100q32 0 54-36.5T640-358q-46 11-80 43.5T526-250q0 14 8 22t22 8Z"/></svg>';

    // console.log('fileNameTypeString', {'string': string, 'layerName': layerName, 'type': type, 'ext': ext})

    switch (ext.toLowerCase()) {
      case "png":
        icon = Image
        break;
      case "jpg":
        icon = Image
        break;
      case "jpeg":
        icon = Image
        break;
      case "webp":
        icon = Image
        break;
      case "svg":
        icon = Svg
        break;
      case "mp4":
        icon = Video
        break;
      case "webm":
        icon = Video
        break;
      case "mov":
        icon = Video
        break;
      case "tab":
        icon = TabBtn
        break;
      case "grp":
        icon = Folder
        break;
      case "popup":
        icon = Popup
        break;
      case "rect":
        icon = rect
        break;
      case "rectangle":
        icon = rect
        break;
      case "ellipse":
        icon = ellipse
        break;
      case "arrow":
        icon = arrow
        break;
      case "star":
        icon = star
        break;
      case "line":
        icon = line
        break;
      case "drawing":
        icon = path
        break;
      case "path":
        icon = path
        break;
      default:
        icon = Wysiwyg
        break;
    }
    if (x2.length > 20) {
      x2 = x2.substring(0,20) + ' ...'
    }
    iconString = '<span>' + icon + "</span>"
    let result = iconString + '<span class="TextItemHeading">' + x2 + '</span>'
    // console.log('iconString', iconString)
    return result
  }
  
  function toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  function round30(x) {
    let y = Math.ceil(x / 30) * 30;
    // console.log('y', y);
    return y;
  }

  function humanizeFontWeight(weight) {
    let r;
    switch (weight) {
      case 'normal':
        r = 'Regular'
        break;
      default:
        r = weight
        break;
    }
    return r
  }

  function stripTags(html) {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}
  

  export {stripImg, getFileType, fileNameType, fileNameTypeString, toTitleCase, round30, humanizeFontWeight, stripTags}